import React from "react";
import "../styles/navbar.css";
import { NavLink } from "react-router-dom";
import DropdownMenu from "../components/DropdownMenu";
import { useAuth } from "../providers/AuthContext";
import UserDropdown from "./userDropdown";


export default function Navbar({permissions}) {
  const {userEmail}  = useAuth()
  console.log(permissions)
  return (
    <div className="w-full shadow-custom">
      <div className="mx-auto my-0 px-[8px] max-w-[1400px]">
        <div className="flex items-center">
          {/* Logo */}
          <div className="float-left h-12 p-2 mx-2">
            <img
              className="h-full w-auto max-w-full"
              alt="logo"
              src={`${process.env.PUBLIC_URL}/images/logos/sens.png`}
            />
          </div>

          {/* Menú de navegación */}
          <ul className="flex flex-wrap list-none relative p-0 m-0">
            {permissions.map(({ label, path, icon, items }) =>
              items.length > 0 ? (
                <DropdownMenu
                  key={label}
                  label={label}
                  icon={`${process.env.PUBLIC_URL}/svg/${icon}`}
                  options={items.map(({ label, path }) => ({
                    to: path,
                    label,
                  }))}
                />
              ) : (
                <NavLink
                  key={label}
                  to={path}
                  className={({ isActive }) =>
                    `flex gap-1 items-center px-6 py-3 cursor-pointer border-b-[2.5px] ${
                      isActive
                        ? "border-bluesens text-gray-700"
                        : "border-transparent text-gray-700"
                    }`
                  }
                >
                  {icon && (
                    <img
                      className="w-4 h-4"
                      alt={label}
                      src={`${process.env.PUBLIC_URL}/svg/${icon}`}
                    />
                  )}
                  {label}
                </NavLink>
              )
            )}
          </ul>

          {/* Espaciador */}
          <span className="flex flex-row flex-1"></span>

          {/* Selector de idioma */}
          <div className="mx-4">
            <select>
              <option> Español</option>
            </select>
          </div>

          {/* Perfil de usuario */}
          <UserDropdown userEmail={userEmail}/>
        </div>
      </div>
    </div>
  );
}
